import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SteppedFormGroupDefinition } from 'components';
import { BaseFormComponent } from '../../components/base-form.component';

@Component({
  standalone: false,
  selector: 'lib-collapsible-form',
  templateUrl: './collapsible-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./collapsible-form.component.scss']
})
export class CollapsibleFormComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  step: string;

  @Input()
  isExpanded = true;

  constructor() {}

  ngOnInit(): void {}
}
